// 路由权限

import router from './router'
import { getToken } from './utils/auth'

// 白名单: 不要认证授权的路由
const whiteRouteList = ['/auth']

router.beforeEach((to) => {
    const accessToke = getToken()
    if (accessToke && accessToke != 'null') {
        // 已经登录
        if (to.path === '/auth') {
            // 重定向到首页
            return { name: 'Home' }
        }
    } else {
        if (whiteRouteList.indexOf(to.path) !== -1) {
            // 白名单
        } else {
            // 非白名单
            return { name: 'Login' }
        }
    }
})